import { useEffect, useState } from "react";
import axios from "../../utils/axiosInstance";
const InventoryReport = () => {
  const [data, setData] = useState(null);
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(false);
  const fetchReport = async () => {
    try {
      setLoading(true);
      const res = await axios.get("/reports/inventory");
      setData(res.data);
    } catch (err) {
      console.error("Error loading inventory report", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReport();
  }, []);
  //   useEffect(() => {
  //     fetch("/reports/inventory")
  //       .then((res) => res.json())
  //       .then((json) => setData(json));
  //   }, []);

  if (!data) return <p>در حال بارگذاری...</p>;

  // فیلتر داده‌ها
  const filtered = data.stockReport.filter((item) => {
    if (filter === "all") return true;
    if (filter === "low") return item.status === "Low Stock";
    if (filter === "out") return item.status === "Out of Stock";
    if (filter === "ok") return item.status === "In Stock";
    return true;
  });

  return (
    <div className="container mt-4">
      {/* خلاصه آماری */}
      <div className="row mb-4">
        <div className="col-md-4 mb-3">
          <div className="card text-center shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Total Inventory Value</h5>
              <h4 className="text-primary">
                ${data.totalInventoryValue.toLocaleString()}
              </h4>
            </div>
          </div>
        </div>
        <div className="col-md-4 mb-3">
          <div className="card text-center shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Finished Products</h5>
              <h4 className="text-danger">{data.outOfStockCount}</h4>
            </div>
          </div>
        </div>
        <div className="col-md-4 mb-3">
          <div className="card text-center shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Out of Stock Products</h5>
              <h4 className="text-warning">{data.lowStockCount}</h4>
            </div>
          </div>
        </div>
      </div>

      {/* فیلتر */}
      <div className="card shadow-sm mb-3">
        <div className="card-body d-flex flex-wrap gap-2">
          <label className="form-label me-2 mb-0">Status Filter:</label>
          <select
            className="form-select w-auto"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          >
            <option value="all">All</option>
            <option value="ok">Stock</option>
            <option value="low">Low Stock</option>
            <option value="out">Non-Existent</option>
          </select>
        </div>
      </div>

      {/* جدول محصولات */}
      <div className="card shadow-sm">
        <div className="card-body">
          <h5 className="card-title mb-3">Product Inventory Report</h5>
          <div className="table-responsive">
            <table className="table table-striped table-bordered table-hover align-middle">
              <thead className="table-dark">
                <tr>
                  <th>Title</th>
                  
                  <th>Category</th>
                  <th>Stock</th>
                  <th>Status</th>
                  <th>Inventory Value</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((item) => (
                  <tr key={item._id}>
                    <td>{item.title}</td>
                    
                    <td>{item.category}</td>
                    <td>{item.stock}</td>
                    <td
                      className={
                        item.status === "Out of Stock"
                          ? "text-danger fw-bold"
                          : item.status === "Low Stock"
                          ? "text-warning fw-bold"
                          : "text-success fw-bold"
                      }
                    >
                      {item.status}
                    </td>
                    <td>${item.stockValue.toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InventoryReport;
